import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "step step-4" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "heading" }, "Inkomster", -1);
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("p", { class: "explanation" }, [
    /*#__PURE__*/ _createTextVNode("Uppgifter markerade med en röd stjärna ("),
    /*#__PURE__*/ _createElementVNode("span", null, "*"),
    /*#__PURE__*/ _createTextVNode(") måste anges för att du skall kunna gå vidare till nästa steg")
], -1);
const _hoisted_4 = { class: "columns" };
const _hoisted_5 = { class: "group calc.applicant" };
const _hoisted_6 = {
    key: 0,
    class: "group-title"
};
const _hoisted_7 = { class: "input" };
const _hoisted_8 = { class: "tooltip-label" };
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", { for: "netIncome" }, [
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createTextVNode("Nettoinkomst/månad"),
        /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*")
    ])
], -1);
const _hoisted_10 = { class: "input" };
const _hoisted_11 = { class: "tooltip-label" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("label", { for: "allowance" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Bostadstillägg/månad")
], -1);
const _hoisted_13 = { class: "input" };
const _hoisted_14 = { class: "tooltip-label" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("label", { for: "capital" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Överskott av kapital/år")
], -1);
const _hoisted_16 = {
    key: 0,
    class: "group calc.coApplicant"
};
const _hoisted_17 = {
    key: 0,
    class: "group-title"
};
const _hoisted_18 = { class: "tooltip-label" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("span", null, "Maka/make", -1);
const _hoisted_20 = {
    key: 1,
    class: "group-title"
};
const _hoisted_21 = { class: "input" };
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createTextVNode("Nettoinkomst/månad"),
    /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*")
], -1);
const _hoisted_23 = { class: "input" };
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("span", null, "Bostadstillägg/månad", -1);
const _hoisted_25 = { class: "input" };
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("span", null, "Överskott av kapital/år", -1);
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("div", { class: "heading" }, "Utgifter", -1);
const _hoisted_28 = { class: "columns group expenditure" };
const _hoisted_29 = { class: "input" };
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("span", null, "Kostnad för god man/månad", -1);
const _hoisted_31 = {
    key: 0,
    class: "input"
};
const _hoisted_32 = { key: 0 };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*", -1);
const _hoisted_34 = { key: 1 };
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*", -1);
const _hoisted_36 = {
    key: 0,
    class: "co-expenditure"
};
const _hoisted_37 = { class: "input" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("span", null, "Kostnad för god man medsökande/månad", -1);
const _hoisted_39 = {
    key: 0,
    class: "input"
};
const _hoisted_40 = { key: 0 };
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*", -1);
const _hoisted_42 = { key: 1 };
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*", -1);
const _hoisted_44 = { class: "columns" };
const _hoisted_45 = { key: 0 };
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("span", { class: "group-title" }, "Egen ägd fastighet", -1);
const _hoisted_47 = { class: "input assessedValue" };
const _hoisted_48 = { class: "tooltip-label" };
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("label", { for: "assessedValue" }, [
    /*#__PURE__*/ _createElementVNode("span", null, [
        /*#__PURE__*/ _createTextVNode("Taxeringsvärde"),
        /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*")
    ])
], -1);
const _hoisted_50 = { class: "input interestExpense" };
const _hoisted_51 = { class: "tooltip-label" };
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("label", { for: "interestExpense" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Räntekostnad/månad")
], -1);
const _hoisted_53 = { class: "input area" };
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createTextVNode("Boyta (Exklusive källare)"),
    /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*")
], -1);
const _hoisted_55 = {
    key: 2,
    class: "group condominium"
};
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("span", { class: "group-title" }, "Bostadsrätt", -1);
const _hoisted_57 = { class: "input apartmentFee" };
const _hoisted_58 = /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createTextVNode("Avgift/månad"),
    /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*")
], -1);
const _hoisted_59 = { class: "input interestCost" };
const _hoisted_60 = { class: "tooltip-label" };
const _hoisted_61 = /*#__PURE__*/ _createElementVNode("label", { for: "interestCost" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Räntekostnader/månad")
], -1);
const _hoisted_62 = { class: "input" };
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("strong", { style: { "display": "block", "margin-bottom": "5px" } }, "Ingår värme i avgiften?", -1);
const _hoisted_64 = { class: "flex" };
const _hoisted_65 = { class: "radio" };
const _hoisted_66 = /*#__PURE__*/ _createElementVNode("label", { for: "heating-yes" }, "Ja", -1);
const _hoisted_67 = { class: "radio" };
const _hoisted_68 = /*#__PURE__*/ _createElementVNode("label", { for: "heating-no" }, "Nej", -1);
const _hoisted_69 = {
    key: 0,
    class: "input livingArea"
};
const _hoisted_70 = /*#__PURE__*/ _createElementVNode("span", null, [
    /*#__PURE__*/ _createTextVNode("Boyta (exkl. källare)"),
    /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*")
], -1);
const _hoisted_71 = /*#__PURE__*/ _createElementVNode("div", { class: "heading" }, "Avgifter", -1);
const _hoisted_72 = { class: "group" };
const _hoisted_73 = { class: "group-title" };
const _hoisted_74 = {
    key: 0,
    title: "obligatoriskt"
};
const _hoisted_75 = { class: "columns" };
const _hoisted_76 = {
    key: 0,
    class: "group-title"
};
const _hoisted_77 = /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*", -1);
const _hoisted_78 = ["value", "id"];
const _hoisted_79 = ["for"];
const _hoisted_80 = { key: 0 };
const _hoisted_81 = /*#__PURE__*/ _createElementVNode("span", { class: "group-title" }, [
    /*#__PURE__*/ _createTextVNode("Medsökande"),
    /*#__PURE__*/ _createElementVNode("abbr", { title: "obligatoriskt" }, "*")
], -1);
const _hoisted_82 = ["value", "id"];
const _hoisted_83 = ["for"];
const _hoisted_84 = { class: "buttons" };
const _hoisted_85 = { class: "flex" };
const _hoisted_86 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon-arrow" }, null, -1);
const _hoisted_87 = { class: "link-title" };
const _hoisted_88 = /*#__PURE__*/ _createElementVNode("span", { class: "icon icon-arrow-rotate-left" }, null, -1);
const _hoisted_89 = { class: "link-title" };
const _hoisted_90 = ["disabled"];
import Tooltip from "./Tooltip.vue";
import NumberInput from "./NumberInput.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Step4',
    props: {
        calc: {},
        props: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        (!_ctx.calc.is.single())
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Sökande"))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _hoisted_9,
                                _createVNode(Tooltip, {
                                    text: _ctx.calc.TooltipText.netIncome
                                }, null, 8, ["text"])
                            ]),
                            _createVNode(NumberInput, {
                                min: "0",
                                id: "netIncome",
                                modelValue: _ctx.calc.applicant.netIncome,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.calc.applicant.netIncome) = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _hoisted_12,
                                _createVNode(Tooltip, {
                                    text: _ctx.calc.TooltipText.allowance
                                }, null, 8, ["text"])
                            ]),
                            _createVNode(NumberInput, {
                                min: "0",
                                id: "allowance",
                                modelValue: _ctx.calc.applicant.allowance,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.calc.applicant.allowance) = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _hoisted_15,
                                _createVNode(Tooltip, {
                                    text: _ctx.calc.TooltipText.capital
                                }, null, 8, ["text"])
                            ]),
                            _createVNode(NumberInput, {
                                id: "capital",
                                min: "0",
                                modelValue: _ctx.calc.applicant.capital,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.calc.applicant.capital) = $event))
                            }, null, 8, ["modelValue"])
                        ])
                    ]),
                    (_ctx.calc.is.caringForBoth() || _ctx.calc.is.married())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            (!_ctx.calc.is.caringForBoth())
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _hoisted_19,
                                        _createVNode(Tooltip, { text: "Även om du endast söker insatser för dig själv så påverkar din makas eller makes inkomst vilken avgift du får" })
                                    ])
                                ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_20, "Medsökande")),
                            _createElementVNode("label", _hoisted_21, [
                                _hoisted_22,
                                _createVNode(NumberInput, {
                                    min: "0",
                                    modelValue: _ctx.calc.coApplicant.netIncome,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.calc.coApplicant.netIncome) = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("label", _hoisted_23, [
                                _hoisted_24,
                                _createVNode(NumberInput, {
                                    min: "0",
                                    modelValue: _ctx.calc.coApplicant.allowance,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.calc.coApplicant.allowance) = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("label", _hoisted_25, [
                                _hoisted_26,
                                _createVNode(NumberInput, {
                                    min: "0",
                                    modelValue: _ctx.calc.coApplicant.capital,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.calc.coApplicant.capital) = $event))
                                }, null, 8, ["modelValue"])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", null, [
                        _createElementVNode("label", _hoisted_29, [
                            _hoisted_30,
                            _createVNode(NumberInput, {
                                min: "0",
                                modelValue: _ctx.calc.applicant.lawyerCost,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.calc.applicant.lawyerCost) = $event))
                            }, null, 8, ["modelValue"])
                        ]),
                        (_ctx.calc.applicant.accommodation.value === 'rent' || _ctx.calc.is.applicantSpecialCare())
                            ? (_openBlock(), _createElementBlock("label", _hoisted_31, [
                                (_ctx.calc.is.applicantSpecialCare())
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                        _createTextVNode("Hyra särskilt boende/äldreboende"),
                                        _hoisted_33
                                    ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                        _createTextVNode("Hyra lägenhet"),
                                        _hoisted_35
                                    ])),
                                _createVNode(NumberInput, {
                                    min: "0",
                                    modelValue: _ctx.calc.applicant.rent,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.calc.applicant.rent) = $event))
                                }, null, 8, ["modelValue"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.calc.is.caringForBoth())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("label", _hoisted_37, [
                                _hoisted_38,
                                _createVNode(NumberInput, {
                                    min: "0",
                                    modelValue: _ctx.calc.coApplicant.lawyerCost,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.calc.coApplicant.lawyerCost) = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            (_ctx.calc.is.optionAvailable.coApplicantRentField())
                                ? (_openBlock(), _createElementBlock("label", _hoisted_39, [
                                    (_ctx.calc.is.coApplicantSpecialCare())
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                                            _createTextVNode("Hyra särskilt boende/äldreboende"),
                                            _hoisted_41
                                        ]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                            _createTextVNode("Hyra lägenhet"),
                                            _hoisted_43
                                        ])),
                                    _createVNode(NumberInput, {
                                        min: "0",
                                        modelValue: _ctx.calc.coApplicant.rent,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.calc.coApplicant.rent) = $event))
                                    }, null, 8, ["modelValue"])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_44, [
                    (_ctx.calc.is.applicantSpecialCare())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45))
                        : _createCommentVNode("", true),
                    (_ctx.calc.is.house())
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["group ownProperty", { 'order1': _ctx.calc.applicant.accommodation.value === 'apartment' }])
                        }, [
                            _hoisted_46,
                            _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                    _hoisted_49,
                                    _createVNode(Tooltip, {
                                        text: _ctx.calc.TooltipText.assessedValue
                                    }, null, 8, ["text"])
                                ]),
                                _createVNode(NumberInput, {
                                    min: "0",
                                    id: "assessedValue",
                                    modelValue: _ctx.calc.applicant.assessedValue,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.calc.applicant.assessedValue) = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("div", _hoisted_51, [
                                    _hoisted_52,
                                    _createVNode(Tooltip, {
                                        text: _ctx.calc.TooltipText.interestExpense
                                    }, null, 8, ["text"])
                                ]),
                                _createVNode(NumberInput, {
                                    id: "interestExpense",
                                    min: "0",
                                    modelValue: _ctx.calc.applicant.interestExpense,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.calc.applicant.interestExpense) = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("label", _hoisted_53, [
                                _hoisted_54,
                                _createVNode(NumberInput, {
                                    min: "0",
                                    modelValue: _ctx.calc.applicant.area,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.calc.applicant.area) = $event))
                                }, null, 8, ["modelValue"])
                            ])
                        ], 2))
                        : _createCommentVNode("", true),
                    (_ctx.calc.is.apartment())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _hoisted_56,
                            _createElementVNode("label", _hoisted_57, [
                                _hoisted_58,
                                _createVNode(NumberInput, {
                                    min: "0",
                                    modelValue: _ctx.calc.applicant.apartmentFee,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.calc.applicant.apartmentFee) = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("div", _hoisted_60, [
                                    _hoisted_61,
                                    _createVNode(Tooltip, {
                                        text: _ctx.calc.TooltipText.interestExpense
                                    }, null, 8, ["text"])
                                ]),
                                _createVNode(NumberInput, {
                                    min: "0",
                                    id: "interestCost",
                                    modelValue: _ctx.calc.applicant.interestCost,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.calc.applicant.interestCost) = $event))
                                }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                                _hoisted_63,
                                _createElementVNode("div", _hoisted_64, [
                                    _createElementVNode("p", _hoisted_65, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            value: true,
                                            id: "heating-yes",
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.calc.applicant.heating) = $event)),
                                            name: "heating"
                                        }, null, 512), [
                                            [_vModelRadio, _ctx.calc.applicant.heating]
                                        ]),
                                        _hoisted_66
                                    ]),
                                    _createElementVNode("p", _hoisted_67, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            value: false,
                                            id: "heating-no",
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.calc.applicant.heating) = $event)),
                                            name: "heating"
                                        }, null, 512), [
                                            [_vModelRadio, _ctx.calc.applicant.heating]
                                        ]),
                                        _hoisted_68
                                    ])
                                ])
                            ]),
                            (!_ctx.calc.applicant.heating)
                                ? (_openBlock(), _createElementBlock("label", _hoisted_69, [
                                    _hoisted_70,
                                    _createVNode(NumberInput, {
                                        min: "0",
                                        modelValue: _ctx.calc.applicant.livingArea,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.calc.applicant.livingArea) = $event))
                                    }, null, 8, ["modelValue"])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("span", _hoisted_73, [
                        _createTextVNode(_toDisplayString(_ctx.props.fee_text.title), 1),
                        (_ctx.calc.is.single())
                            ? (_openBlock(), _createElementBlock("abbr", _hoisted_74, "*"))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", null, [
                            (!_ctx.calc.is.single())
                                ? (_openBlock(), _createElementBlock("span", _hoisted_76, [
                                    _createTextVNode("Sökande"),
                                    _hoisted_77
                                ]))
                                : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.calc.Fees), (key) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    (_ctx.calc.is.optionAvailable.applicantFee(key))
                                        ? (_openBlock(), _createElementBlock("p", {
                                            class: "radio",
                                            key: key
                                        }, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "radio",
                                                value: _ctx.calc.Fees[key],
                                                id: key,
                                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.calc.applicant.fee) = $event)),
                                                name: "fee"
                                            }, null, 8, _hoisted_78), [
                                                [_vModelRadio, _ctx.calc.applicant.fee]
                                            ]),
                                            _createElementVNode("label", { for: key }, [
                                                _createElementVNode("span", null, _toDisplayString(_ctx.calc.Fees[key].label), 1)
                                            ], 8, _hoisted_79),
                                            (_ctx.calc.Fees[key].text)
                                                ? (_openBlock(), _createBlock(Tooltip, {
                                                    key: 0,
                                                    text: _ctx.calc.Fees[key].text
                                                }, null, 8, ["text"]))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 64));
                            }), 256))
                        ]),
                        (_ctx.calc.is.caringForBoth())
                            ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                _hoisted_81,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.calc.Fees), (key) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        (_ctx.calc.is.optionAvailable.coApplicantFee(key))
                                            ? (_openBlock(), _createElementBlock("p", {
                                                class: "radio",
                                                key: key
                                            }, [
                                                _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    value: _ctx.calc.Fees[key],
                                                    id: `second-${key}`,
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.calc.coApplicant.fee) = $event)),
                                                    name: "fee-co"
                                                }, null, 8, _hoisted_82), [
                                                    [_vModelRadio, _ctx.calc.coApplicant.fee]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: `second-${key}`
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.calc.Fees[key].label), 1)
                                                ], 8, _hoisted_83)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 256))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("button", {
                            class: "link linkIcon",
                            onClick: _cache[20] || (_cache[20] = ($event) => (_ctx.calc.gotoStep(_ctx.calc.Step.Accommodation, true)))
                        }, [
                            _hoisted_86,
                            _createElementVNode("span", _hoisted_87, _toDisplayString(_ctx.calc.ButtonStrings.back), 1)
                        ]),
                        _createElementVNode("button", {
                            class: "link linkIcon",
                            onClick: _cache[21] || (_cache[21] = ($event) => (_ctx.calc.resetForm()))
                        }, [
                            _hoisted_88,
                            _createElementVNode("span", _hoisted_89, _toDisplayString(_ctx.calc.ButtonStrings.reset), 1)
                        ])
                    ]),
                    _createElementVNode("button", {
                        class: "themeButton",
                        disabled: _ctx.calc.is.unfulfilled.income(),
                        onClick: _cache[22] || (_cache[22] = ($event) => (_ctx.calc.gotoStep(_ctx.calc.Step.Calculation, true)))
                    }, _toDisplayString(_ctx.calc.ButtonStrings.next), 9, _hoisted_90)
                ])
            ]));
        };
    }
});
